<section class="c-cover c-cover--basic t-flag-grupo-c3">

  <h1 class="c-cover__main-title omega">
    Faça parte da nossa rede de corretores de redações!
  </h1>

  <div class="c-cover__content">
    <h3>
      Se você tem formação em Letras ou Linguística,
      ou está terminando sua graduação, aproveite essa oportunidade
      de fazer parte do nosso time de corretores.
    </h3>

    <p>O Redação Nota 1000 é uma empresa de correção de textos online,
      focada em ENEM, outros vestibulares e ensino fundamental.
      Nós contamos com uma ferramenta de correção exclusiva,
      que agiliza o trabalho da nossa equipe selecionada e
      treinada de corretores, e ajuda o aluno a entender quais são os seus
      pontos fortes e fracos, indicando o que fazer para melhorá-los.
      O progresso de nossos alunos é notável!</p>

    <p>Você está prestes a entrar para esse time que tem ajudado jovens brasileiros a escrever melhor! Além disso, você
      contará com:</p>

    <ul class="c-cover__content-list u-margin-bottom-large u-margin-top-larg">
      <li class="c-cover__content-list-item"> <fa-icon class=" u-icon" [icon]="['fas', 'check']"
          [fixedWidth]="true"></fa-icon>
        Avaliações em gêneros variados: Dissertação ENEM, Fuvest, Unicamp, Ensino Fundamental entre outros.
      </li>

      <li class="c-cover__content-list-item"> <fa-icon class=" u-icon" [icon]="['fas', 'check']"
          [fixedWidth]="true"></fa-icon>
        Alto volume de correções. Ótima oportunidade para ter uma renda extra.
      </li>

      <li class="c-cover__content-list-item"> <fa-icon class=" u-icon" [icon]="['fas', 'check']"
          [fixedWidth]="true"></fa-icon>
        Treinamento exclusivo da Redação Nota 1000.
      </li>

      <li class="c-cover__content-list-item"> <fa-icon class=" u-icon" [icon]="['fas', 'check']"
          [fixedWidth]="true"></fa-icon>
        Suporte completo de nossa equipe pedagógica.
      </li>
    </ul>

    <form *ngIf="formGroup" [formGroup]="formGroup" class="c-cover__content-form">

      <mat-form-field class="c-cover__content-form-form-control c-cover__content-form-form-control--medium"
        appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput formControlName="nome" placeholder="Nome">

        <mat-error *ngIf="formGroup.get('nome').hasError('required')">
          Digite o seu nome. É assim que vamos nos referir a você.
        </mat-error>
      </mat-form-field>

      <mat-form-field class="c-cover__content-form-form-control" appearance="outline">
        <mat-label>CPF</mat-label>
        <input matInput formControlName="cpf" [textMask]="cpfMask" placeholder="999.999.999-99">

        <mat-error *ngIf="formGroup.get('cpf').hasError('required')">
          Digite um CPF válido. O campo cpf é obrigatório.
        </mat-error>
      </mat-form-field>

      <mat-form-field class="c-cover__content-form-form-control" appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" placeholder="Email">

        <mat-error *ngIf="formGroup.get('email').hasError('required')">
          Digite um email válido. O campo Email é obrigatório.
        </mat-error>
      </mat-form-field>

      <mat-form-field class="c-cover__content-form-form-control" appearance="outline">
        <mat-label>Linkedin</mat-label>
        <input matInput formControlName="linkedin" placeholder="linkedin">
      </mat-form-field>

      <span class="c-cover__content-form-form-control">
        <label class="example-margin">Nível superior:</label>
        <mat-radio-group class="c-cover__content-form-form-control--checkbox-group"
          formControlName="professorCandidatoGrauEscolar">
          <mat-radio-button value="SUPERIOR_COMPLETO">Completo</mat-radio-button>
          <mat-radio-button value="CURSANDO_SUPERIOR">Cursando</mat-radio-button>
        </mat-radio-group>
      </span>

      <mat-form-field class="c-cover__content-form-form-control" appearance="outline">
        <mat-label>Instituição de Ensino</mat-label>
        <input matInput formControlName="instituicaoEnsino" placeholder="Instituição de ensino">
      </mat-form-field>

      <mat-form-field class="c-cover__content-form-form-control" appearance="outline">
        <mat-label>Qual Curso</mat-label>

        <mat-select formControlName="professorCandidatoCurso" placeholder="Qual curso ?">
          <mat-option value="LETRAS">
            Letras
          </mat-option>
          <mat-option value="LINGUISTICA ">
            Linguística
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="c-cover__content-form-form-control" appearance="outline">
        <mat-label>Você possui experiência com correções de texto?</mat-label>
        <mat-select formControlName="indExperienciaCorrecaoTexto" placeholder="Ano Escolar">
          <mat-option [value]="true">
            Sim
          </mat-option>
          <mat-option [value]="false">
            Não
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="c-cover__content-form-form-control c-cover__content-form-form-control--bigger"
        appearance="outline">
        <mat-label>Descrição do curso </mat-label>

        <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5"
          placeholder="Descrição do curso" formControlName="dscProfessorCandidatoCurso" [maxlength]="300">
        </textarea>

        <mat-hint align="end">{{ descProofreaderCandidateCtrl.value?.length || 0 }}/300</mat-hint>
      </mat-form-field>

      <mat-form-field class="c-cover__content-form-form-control c-cover__content-form-form-control--bigger"
        appearance="outline">
        <mat-label>Descreva suas experiências com correções. </mat-label>

        <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="5"
          placeholder="Descrição das experiências" formControlName="dscExperiencia" [maxlength]="300">
        </textarea>

        <mat-hint align="end">{{ experiencesCtrl.value?.length || 0 }}/300</mat-hint>
      </mat-form-field>

      <span class="c-cover__content-form-form-control c-cover__content-form-form-control--bigger">
        <mat-label>Qual das habilidades abaixo você tem experiência ?</mat-label>

        <mat-selection-list #skillsSelectionList formControlName="expVestibulares"
          class="c-cover__content-form-form-control--checkbox-item">
          <mat-list-option *ngFor="let skill of skillOptions" [value]="skill">
            {{ skill }}
          </mat-list-option>
        </mat-selection-list>
      </span>

      <div class="c-cover__content-form-form-control c-cover__content-form-form-control--bigger">
        <button matRipple (click)="submit()"
          class="c-button c-button--large c-button--solid c-cover__content-form-form-control-button "
          [disabled]="formGroup?.invalid">
          Enviar
        </button>
      </div>

    </form>


  </div>

</section>